import { useQuery } from "@tanstack/react-query"
import { useTRPCClient } from "utils/trpc"

export const useAvailableEcosystemMetricIds = ({
  dataId,
}: { dataId?: string } = {}) => {
  const trpcClient = useTRPCClient()
  return useQuery({
    queryKey: ["getMetricsEcosystemsAvailability", dataId],
    queryFn: () => {
      return trpcClient.metrics.getEcosystemAvailability
        .query({
          data_ids: dataId ? [dataId] : undefined,
        })
        .then((res) => res.data.map((item) => item.metric_id))
    },
    staleTime: 1000 * 60 * 10,
  })
}
